module.exports = __webpack_public_path__ + "static/media/stripe_logo.14e67e24.png";